import createIcon from '../../createIcon';

/**
 * @component @name Woman
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuOTQgOC4zMUMxMy42MiA3LjUyIDEyLjg1IDcgMTIgN0MxMS4xNSA3IDEwLjM4IDcuNTIgMTAuMDYgOC4zMUw3IDE2SDEwVjIySDE0VjE2SDE3TDEzLjk0IDguMzFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgNkMxMy4xMDQ2IDYgMTQgNS4xMDQ1NyAxNCA0QzE0IDIuODk1NDMgMTMuMTA0NiAyIDEyIDJDMTAuODk1NCAyIDEwIDIuODk1NDMgMTAgNEMxMCA1LjEwNDU3IDEwLjg5NTQgNiAxMiA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Woman = createIcon('Woman', [
  [
    'path',
    {
      d: 'M13.94 8.31C13.62 7.52 12.85 7 12 7C11.15 7 10.38 7.52 10.06 8.31L7 16H10V22H14V16H17L13.94 8.31Z',
      key: '1vxkv0',
    },
  ],
  [
    'path',
    {
      d: 'M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z',
      key: '1cb55s',
    },
  ],
]);

export default Woman;
